import { render, staticRenderFns } from "./CustomQuillEditor.vue?vue&type=template&id=1150a68b&"
import script from "./CustomQuillEditor.vue?vue&type=script&lang=js&"
export * from "./CustomQuillEditor.vue?vue&type=script&lang=js&"
import style0 from "./CustomQuillEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports